import React from 'react';
import PropTypes from 'prop-types';
import './style';
import { Button, Card, Badge } from 'react-bootstrap'


const PortfolioItem = (props, context) => {
  const { theme: { colorPrimary, textAlternate } } = context;

  if (props.render) return props.render;
  else
    return (

<Card >
  <Card.Img variant="top" />
  <Card.Body>
    <Card.Title>Card Title</Card.Title>
    <Card.Text>
      Some quick example text to build on the card title and make up the bulk of
      the card's content.
    </Card.Text>
    <Button variant="primary">Go somewhere</Button>
    <Button variant="primary">Go somewhere</Button>
  </Card.Body>
</Card>
        );
};

PortfolioItem.contextTypes = {
  theme: PropTypes.any
};

export default PortfolioItem;



// WEBPACK FOOTER //
// ./src/components/PortfolioItem/PortfolioItem.js